import { createSlice } from '@reduxjs/toolkit';

import { DELETE_CLASS_MODAL_STAGES } from '@classCreation/data/deleteClassModalStages';

const initialState = {
  modalStage: DELETE_CLASS_MODAL_STAGES.notOpen,
  communications: {},
  selectedSbatGroup: null,
  deleteReason: null,
  deleteSbatGroupErrorMessage: null,
};

export const deleteSbatGroup = createSlice({
  name: 'deleteSbatGroup',
  initialState,
  reducers: {
    setDeleteClassModalStage: (state, action) => {
      state.modalStage = action.payload;
    },
    setDeleteSbatGroupCommunications: (state, action) => {
      state.communications[action.payload.channel] = action.payload.enabled;
    },
    setSelectedDeleteSbatGroup: (state, action) => {
      state.selectedSbatGroup = action.payload;
    },
    setDeleteSbatGroupErrorMessage: (state, action) => {
      state.deleteSbatGroupErrorMessage = action.payload;
    },
    setDeleteReason: (state, action) => {
      state.deleteReason = action.payload;
    },
    resetDeleteModal: (state, _) => {
      state.modalStage = DELETE_CLASS_MODAL_STAGES.notOpen;
      state.communications = {};
      state.selectedSbatGroup = null;
      state.deleteReason = null;
    },
  },
});

export const {
  resetDeleteModal,
  setDeleteSbatGroupCommunications,
  setDeleteReason,
  setDeleteClassModalStage,
  setSelectedDeleteSbatGroup,
  setDeleteSbatGroupErrorMessage,
} = deleteSbatGroup.actions;
export default deleteSbatGroup.reducer;
